<template>
  <v-card v-if="master" flat class="mb-1">
    <v-switch
        class="mt-1"
        v-model="prop_locked"
        label="Locked"
        color="success"
        hide-details
    />
    <v-switch
        class="mt-1"
        v-model="prop_enabled"
        label="Enabled"
        color="success"
        hide-details
    />
  </v-card>
  <v-card v-else flat class="mb-5">
    <v-switch
        v-model="prop_enabled"
        label="Enabled"
        color="success"
        hide-details
    />
  </v-card>
</template>

<script>
import VueTypes from "vue-types";

export default {
  name: "r-authorize",
  props: {
    master: VueTypes.bool.def(false),
    locked: VueTypes.bool.def(false),
    enabled: VueTypes.bool.def(false)
  },
  computed: {
    prop_locked: {
      get() {
        return this.locked;
      },
      set(value) {
        this.$emit("update:locked", value);
      }
    },
    prop_enabled: {
      get() {
        return this.enabled;
      },
      set(value) {
        this.$emit("update:enabled", value);
      }
    }
  }
}
</script>